var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_15",
    "data-name": "Group 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 93.674,
    height: 97.049,
    viewBox: "0 0 93.674 97.049",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    width: 93.674,
    height: 97.049,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M92.417,176.355H11.406a1.44,1.44,0,1,1,0-2.881H92.417a1.44,1.44,0,1,1,0,2.881",
    transform: "translate(-5.003 -87.086)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M92.379,191.978H1.731a1.44,1.44,0,1,1,0-2.881H92.379a1.44,1.44,0,1,1,0,2.881",
    transform: "translate(-0.146 -94.929)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    width: 2.881,
    height: 39.792,
    transform: "translate(12.664 43.714)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    width: 2.881,
    height: 39.792,
    transform: "translate(22.172 43.714)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    width: 2.881,
    height: 39.792,
    transform: "translate(40.714 43.714)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    "data-name": "Rectangle 13",
    width: 2.881,
    height: 39.792,
    transform: "translate(50.223 43.714)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    width: 2.881,
    height: 39.792,
    transform: "translate(68.764 43.714)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15",
    "data-name": "Rectangle 15",
    width: 2.881,
    height: 39.792,
    transform: "translate(78.273 43.714)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M91.573,32.62a1.435,1.435,0,0,1-.8-.242L46.9,3.166,2.23,32.384A1.44,1.44,0,0,1,.653,29.974L46.119.235a1.44,1.44,0,0,1,1.587.006L92.373,29.98a1.441,1.441,0,0,1-.8,2.64",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M36.349,78.222H19.234a1.44,1.44,0,1,1,0-2.881H36.349a1.44,1.44,0,1,1,0,2.881",
    transform: "translate(-8.932 -37.822)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M92.676,78.222H75.561a1.44,1.44,0,1,1,0-2.881H92.676a1.44,1.44,0,1,1,0,2.881",
    transform: "translate(-37.209 -37.822)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M149,78.222H131.889a1.44,1.44,0,1,1,0-2.881H149a1.44,1.44,0,1,1,0,2.881",
    transform: "translate(-65.487 -37.822)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M92.512,65.493H19.358a1.44,1.44,0,1,1,0-2.881H92.512a1.44,1.44,0,1,1,0,2.881",
    transform: "translate(-8.995 -31.432)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M87.062,38.52a7.073,7.073,0,1,1,0-14.146,1.44,1.44,0,1,1,0,2.881,4.192,4.192,0,1,0,4.192,4.192,1.441,1.441,0,0,1,2.881,0,7.081,7.081,0,0,1-7.073,7.073",
    transform: "translate(-40.156 -12.236)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.afe5bce41e772beee1b0ff5af1f047ff.svg";
export { ForwardRef as ReactComponent };